import(/* webpackMode: "eager" */ "D:\\workspace\\AIFO-Agent-FE\\node_modules\\next\\font\\google\\target.css?{\"path\":\"src\\\\app\\\\layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"variable\":\"--font-inter\",\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "D:\\workspace\\AIFO-Agent-FE\\src\\app\\globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["LoginDialogProvider"] */ "D:\\workspace\\AIFO-Agent-FE\\src\\components\\login-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "D:\\workspace\\AIFO-Agent-FE\\src\\components\\ui\\sonner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "D:\\workspace\\AIFO-Agent-FE\\src\\contexts\\auth-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "D:\\workspace\\AIFO-Agent-FE\\src\\contexts\\language-context.tsx");
